"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocationPositionFromLatLngLiteral = exports.getLatLngLiteralFromAddressLocation = exports.getLatLngLiteralFromLocationPosition = exports.isPlaceWithinRadius = exports.transformCenterWithRadiusToLatLngBounds = exports.parsePlaceResultResponse = exports.getCountryCodeFromAddressComponents = void 0;
const getCountryCodeFromAddressComponents = (addressComponents) => {
    const countryInfo = addressComponents.find((ac) => ac.types[0] === "country");
    if (!countryInfo?.short_name) {
        return "";
    }
    return countryInfo.short_name.toLowerCase();
};
exports.getCountryCodeFromAddressComponents = getCountryCodeFromAddressComponents;
const parsePlaceResultResponse = (description, placeDetails) => {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { address_components, geometry } = placeDetails || {};
    return {
        name: description,
        countryIsoCode: address_components ? (0, exports.getCountryCodeFromAddressComponents)(address_components) : "",
        position: geometry && geometry.location
            ? {
                latitude: geometry.location.lat(),
                longitude: geometry.location.lng(),
            }
            : undefined,
    };
};
exports.parsePlaceResultResponse = parsePlaceResultResponse;
// Note: requires google maps API with geometry library to be loaded
function transformCenterWithRadiusToLatLngBounds(center, radiusMeters) {
    const northEast = google.maps.geometry.spherical.computeOffset(google.maps.geometry.spherical.computeOffset(center, radiusMeters, 90), radiusMeters, 0);
    const southWest = google.maps.geometry.spherical.computeOffset(google.maps.geometry.spherical.computeOffset(center, radiusMeters, -90), radiusMeters, -180);
    return new google.maps.LatLngBounds(southWest, northEast);
}
exports.transformCenterWithRadiusToLatLngBounds = transformCenterWithRadiusToLatLngBounds;
const isPlaceWithinRadius = (place, restrictToArea) => {
    if (!place.distance_meters) {
        return true;
    }
    return restrictToArea ? place.distance_meters <= restrictToArea?.radiusInMeters : true;
};
exports.isPlaceWithinRadius = isPlaceWithinRadius;
const getLatLngLiteralFromLocationPosition = (position) => {
    return { lat: position.latitude, lng: position.longitude };
};
exports.getLatLngLiteralFromLocationPosition = getLatLngLiteralFromLocationPosition;
const getLatLngLiteralFromAddressLocation = (location) => {
    if (!location.position) {
        return undefined;
    }
    return { lat: location.position.latitude, lng: location.position.longitude };
};
exports.getLatLngLiteralFromAddressLocation = getLatLngLiteralFromAddressLocation;
const getLocationPositionFromLatLngLiteral = (latLngLiteral) => {
    return { latitude: latLngLiteral.lat, longitude: latLngLiteral.lng };
};
exports.getLocationPositionFromLatLngLiteral = getLocationPositionFromLatLngLiteral;
//# sourceMappingURL=AddressAutocomplete.utils.js.map